class RoutingHelpers {
    static navigate(url, e, angularRouter, angularNgZone) {
        if (angularRouter) {
            if (false === /^http(?:s)?:\/{2}\S+$/.test(url)) {
                this.navigateWithAngular(url, angularRouter, angularNgZone, e);
                return;
            }
        }
        location.href = url;
    }
    static navigateWithAngular(url, angularRouter, angularNgZone, e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (false === /^http(?:s)?:\/{2}\S+$/.test(url)) {
            if (angularNgZone) {
                angularNgZone.run(() => angularRouter.navigateByUrl(url));
                return;
            }
            angularRouter.navigateByUrl(url);
        }
        location.href = url;
    }
}

export { RoutingHelpers as R };

//# sourceMappingURL=routing-helpers-c737a977.js.map